<template>
  <b-container> 
  <div class="my-3 p-3 bg-white rounded shadow-sm">  
        <h4 class="border-bottom border-gray pb-2 mb-0">Últimos clientes registrados</h4>
        <div class="media text-muted pt-3">  
            <b-table
            show-empty
            small
            stacked="md"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            >
            <template v-slot:cell(name)="row">
                {{ row.value.first }} {{ row.value.last }}
            </template>
            <template v-slot:cell(created)="row">
                {{ row.item.created | formatDate }} 
            </template>
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                Info modal
                </b-button>
                <b-button size="sm" @click="row.toggleDetails">
                {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                </b-button>
            </template>

            <template v-slot:row-details="row">
                <b-card>
                <ul>
                    <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
                </b-card>
            </template>
            </b-table> 
        </div>
  </div>
    

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal> 
  </b-container>
</template>
 
<script> 
import axios from 'axios'
  export default {
    data() {
      return {
        items: [
        
        ],
        fields: [ 
            { key: 'firstname', label: 'Nombre' }, 
            { key: 'lastname', label: 'Apellido' }, 
            { key: 'phoneNumber', label: 'Teléfono' },  
            //{ key: 'email', label: 'Correo electrónico' },  
            //{ key: 'servicesNumbers', label: 'No. Servicios' },
            //{ key: 'cotizacions', label: 'No. Cotizaciones' },
            { key: 'created', label: 'Registro'}
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 5,
        pageOptions: [5, 10, 15],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
      }
    },
    computed: {

      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
    mounted() {
        
      // Set the initial number of items
      this.totalRows = this.items.length
        this.listar()
    }, 
    methods: {
        listar(){
            let me=this; 
            axios.get('customers/'+this.$store.state.usuario._id+'/status=true/1').then(function (response){ 
                me.totalRows = response.data.length;
                me.items=response.data.customers;
            }).catch(function(error){
            });
        },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    }
  }
</script>
<style>
table.table { 
  font-family: 'Karla', sans-serif;  
  color: #444 !important;
}
table.table thead {
  background: #F4F4F4; 
  border: 0px transparent; 
  font-family: 'Karla', sans-serif; 
  font-weight: 700 !important; 
  color: #444 !important;
}
h4 {
  font-family: 'Karla', sans-serif; 
  font-weight: 700 !important; 
  color: #000 !important;
  font-size: 22px !important; 
}
</style>